import { render, staticRenderFns } from "./selectInvoiceType.vue?vue&type=template&id=51a38e5f"
import script from "./selectInvoiceType.vue?vue&type=script&lang=js"
export * from "./selectInvoiceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports